















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import { InspectService } from "@/service/inspectService";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import {
  InspectGensha,
  InspectGenshaCategory,
  InspectGenshaSubItem,
  InspectDescriptions
} from "@/model/InspectGensha";
import { InspectState } from "@/store/modules/inspectStore";
import { SocketControllers } from "@/service/SocketControllers";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { Utils } from "@/service/util";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import { CarSelectData } from "@/model/CarSelection";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { InspectItem, InspectValueItem } from "@/model/InspectItem";
import { Work } from "@/model/Work";
import InspectValueDialog from "@/components/InspectValueDialog.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";
import { InspectLineResult } from "@/model/InspectLineResult";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { InspectRecommendSubItem, InspectRecommendCategory } from "@/model/InspectRecommend";
import { RouteInfo } from "@/model/RouteInfo";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import { createGenshaInspectionSelectionsRouteService } from "@/service/createGenshaInspectionSelectionsRouteService";
import { createJizenInspectionSelectionsRouteService } from "@/service/createJizenInspectionSelectionsRouteService";
import { createLegal56InspectionSelectionsRouteService } from "@/service/createLegal56InspectionSelectionsRouteService";
import { GenshaInspectionSelectionsRouteService } from "@/model/GenshaInspectionSelectionsRouteService";
import { JizenInspectionSelectionsRouteService } from "@/model/JizenInspectionSelectionsRouteService";
import { Legal56InspectionSelectionsRouteService } from "@/model/Legal56InspectionSelectionsRouteService";
import { WORK_AND_BUHIN_MODE } from "@/model/WorkAndBuhinData";

 // refactor : 現状はmodel式。serviceにはなっていない
import * as WorkBuhinInspectionSelections from "@/components/work-buhin/WorkBuhinInspectionSelections";

const namespaceInspect = "Inspect";
@Component({
  components: {
    ButtonInspect,
    ButtonInspectGroup,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin,
    InputNumber,
    InspectValueDialog
  }
})
export default class InspectionSelections extends Vue {
  readonly INSPECT_VALUE_VIEW_TYPE = INSPECT_VALUE_VIEW_TYPE;
  inspectType: number = 0;
  data: InspectGensha = {};
  service: InspectService;
  reqService: requestService;
  routeService:
    GenshaInspectionSelectionsRouteService |
    JizenInspectionSelectionsRouteService |
    Legal56InspectionSelectionsRouteService;
  ippanSeibiService: IppanSeibiService;
  sktControll: SocketControllers;
  activeCategory: number = 0;
  currentData: InspectGenshaSubItem[] = [];
  loadData: boolean = false;
  errorMsg: string = "";
  headerTopic: string = "";
  apiPath: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  timerSave: any = null;
  timerClick: any = null;
  tempInspect: InspectDescriptions;
  buttonIndex: number = -1;
  activeInspect: any = {};
  activeSubCateIndex: number = -1;
  msgAskChangeInspectResult: string = MESSAGE.AskChangeInspectResult;
  tempBtnIndex: number = -1;
  tempBtnIndexList: number[] = [];
  tempListSave: InspectDescriptions[] = [];
  tempSaveRef: any = {};
  arrStatus: number[] = [];
  isSaving: boolean = false;
  tempListSaving: InspectDescriptions[] = [];
  timerSaving: any = null;
  tempWaitSave: any = [];
  isCallSaveWhenSaving: boolean = false;
  tempDataSave: any = null;
  isSocket: boolean = false;
  inspectList: InspectDescriptions[] = [];
  isOsusume: boolean = false;
  kingakuFlg: boolean = false;
  activeSubCategory: number = 0;
  maxRowNum: number = 0;
  tempOsusumeListSave: InspectRecommendSubItem[] = [];
  tempOsusumeInspect: InspectRecommendSubItem;
  tempIndex: number = -1;
  btnCateNm: any = [];
  isExitConnectSocket: boolean = false;
  $refs!: {
    buttonGroup: ButtonInspectGroup[];
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    confirmDialog: ConfirmDialog;
    confirmRegisterDialog: ConfirmDialog;
    workBuhinDialog: WorkAndBuhin;
    cancelDialog: ConfirmDialog;
    osusumeConfirmDialog: ConfirmDialog;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    freeSeibiNotSectingBuhinDialog: ConfirmDialog;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  };

  /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
  cateLoadingList: any = {};
  /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */
  public utils: Utils = new Utils();

  @Getter("sknUketsukeExtends", { namespace: "ReservationDetail" })
  sknUketsukeExtends: SknUketsukeExtends;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("inspect", { namespace: namespaceInspect })
  inspect!: (index: number) => InspectGensha;
  @Getter("hasData", { namespace: namespaceInspect })
  hasData!: (index: number) => boolean;

  @Action("setInspect", { namespace: namespaceInspect })
  setInspect: any;
  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setStateCarSelection: any;

  @Action("setState", { namespace: "InspectLine" })
  setState: any;
  @Action("hasData", { namespace: "InspectLine" })
  hasInspectLine: any;

  @Getter("useLine", { namespace: "InspectionDetail" })
  useLine: boolean;
  @Getter("sideSlipValue", { namespace: "InspectLine" })
  sideSlipValue: any;
  @Action("setSideSlip", { namespace: "InspectLine" })
  setSideSlip: any;

  @Getter("inspectLineList", { namespace: "InspectLine" })
  inspectLineList: InspectLineResult[];

  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;

  /** 2021-12-01 sh #7587 change checking of seibiIds. [START] */
  @Action("setState", { namespace: "SeibiIds" })
  setStateSeibiDetailIds: any;
  /** 2021-12-01 sh #7587 change checking of seibiIds. [END] */

  @Action("setInspectRecommend", { namespace: namespaceInspect })
  setInspectRecommend: any;

  /** 2021-11-19 sh #7530 improve speed.(for back) [START] */
  @Getter("currentState", { namespace: "RouteState" })
  lastSelectedCategoryInfo!: (index: number) => RouteInfo;
  @Getter("hasState", { namespace: "RouteState" })
  hasLastSelectedCategoryInfo!: (index: number) => boolean;

  @Action("setState", { namespace: "RouteState" })
  setRouteInfo: any;
  /** 2021-11-19 sh #7530 improve speed.(for back) [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積
  @Getter("isInspectionLessInput", { namespace: "FunctionSetting" })
  isInspectionLessInput: boolean | null; // システム設定B 車検の検査構成画面の入力を減らす
  @Getter("isLaurelCustom", { namespace: "FunctionSetting" })
  isLaurelCustom: boolean | null; // システム設定C ローレル要望
  @Getter("kariIppanSeibiD", { namespace: "FunctionSetting" })
  kariIppanSeibiD: boolean | null; // システム設定D 手数料マスタ
  @Getter("kariIppanSeibiF", { namespace: "FunctionSetting" })
  kariIppanSeibiF: boolean | null; // システム設定F 工数・部品利用

  @Getter("freeOfChargeLabelFull", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  @Getter("freeOfChargeLabelMsg", { namespace: "FunctionSetting" })
  freeOfChargeLabelMsg: any;

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.setInspectType(to.name);
    this.currentData = [];
    this.activeCategory = 0;
    this.$set(this, "isSaving", false);
    this.$nextTick(() => {
      this.initPage();
    });
  }

  setInspectType(routeName: string) {
    // 呼び出しURLに応じたインターフェースの用意
    switch (routeName) {
      case "legal56":
        this.routeService = createLegal56InspectionSelectionsRouteService(
          this.reqService
        );
        break;
      case "jizen":
        this.routeService = createJizenInspectionSelectionsRouteService(
          this.reqService
        );
        break;
      default:
        this.routeService = createGenshaInspectionSelectionsRouteService(
          this.reqService
        );
        break;
    }

    this.inspectType = this.routeService.inspectType;
    this.headerTopic = this.routeService.headerTopic;
    this.apiPath = this.routeService.apiPath;
  }

  getPathName(): string {
    if (this.$route.name) {
      return this.$route.name;
    }
    return "";
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("updateCourseSubscription",this.initPage); // catchSocket:08車検コース変更による再描画指示
    this.sktControll.connectSocket();
  }

  created() {
    this.reqService = new requestService();
    this.setInspectType(this.getPathName());
    this.service = new InspectService();
    this.ippanSeibiService = new IppanSeibiService();
    this.connectSocket();
    this.initPage();
  }

  initPage() {
    // 2022-01-31 morisako kobac-free add [START]
    this.reqService.setFreeOfCharge(this.uketsukeExtendsId).then((res: any) => {
      if (res) {
    // 2022-01-31 morisako kobac-free add [END]
    this.$emit("onactivepage", this.$route.name);
    this.closeDialogWork();
    // if (this.hasData(this.inspectType)) {
    //   this.data = this.inspect(this.inspectType);
    //   this.setCurrentData();
    //   this.loadData = true;
    // } else {
    this.loadData = false;
    this.loading = false;
    /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
    // this.reqService.getInspect(this.uketsukeExtendsId, this.apiPath).then(
    const promise = this.getInspectPM(this.uketsukeExtendsId, this.apiPath);
    Promise.all(promise).then((val: any) => { // 2021-12-01 sh #7587 change array to object.

        /** 2021-12-01 sh #7587 change check seibiIds. [START] */
        // const res: any = val[0];
        const resSeibiIds: any = val[0];
        const resData: any = val[1];

        this.setStateSeibiDetailIds(resSeibiIds);
        /** 2021-12-01 sh #7587 change check seibiIds. [END] */

    /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
        this.loadData = true;
        if (resData) {
          const initialRouteDataState =
            this.routeService.buildInitialData(resData);
          this.data = initialRouteDataState.data;

          /** 残りの点検を取得する */
          if (initialRouteDataState.categoryItems.length > 0) {
            initialRouteDataState.lazyLoadCategoryIds.forEach((categoryId: any) => {
              this.getInspectByCategoryId(
                this.uketsukeExtendsId,
                this.apiPath,
                categoryId
              );
            });
            this.changeCategoryByLastSelected(
              initialRouteDataState.categoryItems.length
            );
          }

          this.setProgressState({
            stateId: initialRouteDataState.progressState.stateId,
            stateNm: initialRouteDataState.progressState.stateNm
          });
          if (this.routeService.hasCurrentCategories(this.data)) {
            this.addStatus();
            // this.setSideSlipData(this.data[this.apiPath][0]);
            this.$set(this, "isSaving", false);
          }
        }
      },
      (err: any) => {
        this.loadData = true;
        this.onError(err);
      }
    );
    // }
    // 2022-01-31 morisako kobac-free add [START]
      }
    });
    // 2022-01-31 morisako kobac-free add [END]
  }

  get strSknSeibiShubetsuKbn(): string {
    return this.routeService.getSknSeibiShubetsuKbn(
      this.sknUketsukeExtends
    );
  }

  get categories(): any[] {
    return this.routeService
      ? this.routeService.extractCurrentCategories(this.data)
      : [];
  }

  get workAndBuhinInspectMode(): number {
    return WORK_AND_BUHIN_MODE.INSPECT;
  }

  get workAndBuhinJizenRecommendMode(): number {
    return WORK_AND_BUHIN_MODE.JIZEN_RECOMMEND;
  }
  /** 2021-11-19 sh #7530 improve speed.(for back) [START] */
  getInspectPM(uketsukeExtendsId: any, apiPath: any) {
    if (this.isNextageCustom) {
      // コース変更後の再描画、再ロードと進んだときに前回のデータがあると、判定の選択実行、checked起動となり判定情報を書き換えようとする
      // 通常は再ロードの結果で後から更新処理が重なり、正しい判定情報に書き戻すのだが、この処理は初期値以外でないと発生しない。
      // ネクステージ用のコース変更では初期化する動作があり、そのままだとロードした結果を前回のデータで上書きしてしまう
      this.currentData = [];
    }
    let promise;
    if (this.hasLastSelectedCategoryId()) {
      /** 「戻る」ボタンで戻った場合、最後に開いていたカテゴリを開く。 */
      let sknInspectCategoryId: any = this.getLastSelectedCategoryId();
      promise = new Promise((resolve, reject) => {
        this.routeService.getInspectByCategoryId(
          uketsukeExtendsId,
          sknInspectCategoryId,
          this.strSknSeibiShubetsuKbn
        ).then(
          (res: any) => {
            resolve(res);
        }, (err: any) => reject(err));
      });
    } else {
      /** 初めてアクセスする場合 */
      promise = new Promise((resolve, reject) => {
        // this.reqService.getInspect(uketsukeExtendsId, apiPath).then(
        this.routeService.getInspect(
          uketsukeExtendsId,
          this.strSknSeibiShubetsuKbn
        ).then(
          (res: any) => {
            resolve(res);
        }, (err: any) => reject(err));
      });
    }

    /** 2021-12-01 sh #7587 change check seibiIds. [START] */
    const promiseSeibiIds = this.getSelectingSeibiIdsPM(uketsukeExtendsId);
    // return promise;
    return [promiseSeibiIds, promise];
    /** 2021-12-01 sh #7587 change check seibiIds. [END] */
  }

  /** 2021-12-01 sh #7587 change check seibiIds. [START] */
  getSelectingSeibiIdsPM(uketsukeExtendsId: any) {
    const promiseSeibiIds = new Promise((resolve, reject) => {
      this.reqService.getSelectingSeibiIds(uketsukeExtendsId).then((res: any) => {
          /** 取得したseibiIdのリストを保存する */
          resolve(res);
      }, (err: any) => {
        if (err && err.status && err.status == 204) {
          resolve([]);
        } else {
          reject(err);
        }
      });
    });
    return promiseSeibiIds;
  }
  /** 2021-12-01 sh #7587 change check seibiIds. [END] */

  hasLastSelectedCategoryId() {
    return this.hasLastSelectedCategoryInfo(this.inspectType);
  }

  getLastSelectedCategoryId() {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(this.inspectType)
      : null;
    return WorkBuhinInspectionSelections.resolveInspectionSelectionsLastSelectedValue(
      this.hasLastSelectedCategoryId(),
      lastCategoryInfo,
      "sknInspectCategoryId",
      undefined
    );
  }

  getLastSelectedPos() {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(this.inspectType)
      : null;
    return WorkBuhinInspectionSelections.resolveInspectionSelectionsLastSelectedValue(
      this.hasLastSelectedCategoryId(),
      lastCategoryInfo,
      "pos",
      -1
    );
  }

  getLastSelectedSubPos() {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(this.inspectType)
      : null;
    return WorkBuhinInspectionSelections.resolveInspectionSelectionsLastSelectedValue(
      this.hasLastSelectedCategoryId(),
      lastCategoryInfo,
      "subPos",
      -1
    );
  }

  posToSknInspectCategoryId(pos: any) {
    return WorkBuhinInspectionSelections.resolveInspectionSelectionsCategoryIdByPosition(
      this.routeService.extractCurrentCategories(this.data),
      pos
    );
  }

  changeCategoryByLastSelected(length: number) {
    const lastCategoryInfo: any = this.hasLastSelectedCategoryId()
      ? this.lastSelectedCategoryInfo(this.inspectType)
      : null;
    const restoreState = WorkBuhinInspectionSelections.resolveInspectionSelectionsRestoreState({
      hasLastSelectedCategoryId: this.hasLastSelectedCategoryId(),
      lastCategoryInfo,
      length,
      inspectType: this.inspectType,
      jizenType: INSPECT_TYPE.JIZEN
    });
    if (restoreState.shouldRestoreCategory) {
      this.changeCategory(restoreState.pos);
      if (restoreState.shouldRestoreSubCategory) {
        this.changeSubCategory(restoreState.subPos);
      }
    /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [START] */
    } else if (restoreState.shouldScrollToFirstIncomplete) {
      setTimeout(()=> {
        this.scrollToFirstIncomplete();
      }, 100);
    /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [END] */
    }
  }
  /** 2021-11-19 sh #7530 improve speed.(for back) [END] */

  addStatus() {
    this.btnCateNm = [];
    let promise = this.routeService.extractCurrentCategories(this.data)
      .map((cate: any) => {
      if (cate.sknInspectCategoryNm ) {
        let key: number = this.btnCateNm.length; 
        this.btnCateNm[key] = cate.sknInspectCategoryNm;
      }
      
      if (!cate.osusume) {
      cate.subItems.forEach((item: InspectGenshaSubItem, i: any) => {
        item.inspectDescriptions = item.inspectDescriptions.map(
          (obj: InspectDescriptions) => {
            if (obj.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
              obj.seibiList.forEach(seibi => {
                if (seibi.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
                  let inspectList = item.inspectDescriptions.filter(
                    inspect =>
                      inspect.sknInspectDescriptionId !=
                      obj.sknInspectDescriptionId
                  );
                  if (
                    obj.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
                  ) {
                    let subCatIndex = 0;
                    if (i == 0) {
                      subCatIndex = 1;
                    }
                    inspectList = inspectList.concat(
                      cate.subItems[subCatIndex].inspectDescriptions
                    );
                  }
                  this.service.autoSetDuplicateSeibi(
                    inspectList,
                    seibi,
                    (inspectChanged: any, index: number) => {
                      item.inspectDescriptions[index].status =
                        InspectButtonStatus.COMPLETED;
                      item.inspectDescriptions[index].workBuhinSelected =
                        inspectChanged.workBuhinSelected;
                    }
                  );
                }
              });
            }
            this.changeStatus(obj, false, true);
            return obj;
          }
        );
      });
      const statusState = WorkBuhinInspectionSelections.buildInspectionSelectionsNormalCategoryStatusState(
        cate.subItems
      );
      cate.subItems = statusState.subItems;
      this.setCateStatus(statusState.sumStatus, statusState.nItem, cate);
      } else {
        cate.recommend.forEach((subCate: any, i: any) => {
          const recommendStatusState =
            WorkBuhinInspectionSelections.buildInspectionSelectionsRecommendCategoryStatusState({
              subItems: subCate.subItems,
              doneStatus: STATUS_SELECT_WORK_BUHIN.Done,
              noNeedStatus: STATUS_SELECT_WORK_BUHIN.NoNeed,
              completedStatus: InspectButtonStatus.COMPLETED,
              incompleteStatus: InspectButtonStatus.INCOMPLETE
            });
          subCate.subItems = recommendStatusState.subItems;
          this.setOsusumeCateStatus(
            recommendStatusState.sumStatus,
            recommendStatusState.nItem,
            subCate
          );
        });
      }
      return cate;
    });
    Promise.all(promise).then((res: any) => {
      // console.log("Promise.all", res);
      this.routeService.replaceCurrentCategories(this.data, res);
      this.setCurrentData(false);
      this.setInspect({ data: this.data, index: this.inspectType });
    });
  }

  setDataFromMD3(cate: InspectGenshaCategory) {
    // ネクステージでは作業部品選択で必須の情報になるのでF5等で欠けているときは自動補完する
    // ※ネクステージ以外でもF5を使いたいので isNextageCustom 条件を外した
    if (!this.carSelection.jidoushaShubetsu) {
      this.reqService
          .getCarSelection(this.uketsukeExtendsId)
          .then((res: any) => {
            res.sknUketsukeExtendsId = this.uketsukeExtendsId;
            this.setStateCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.setDataFromMD3(cate);
          });
      return;
    }

    const md3RouteFlags = WorkBuhinInspectionSelections.buildInspectionSelectionsMd3RouteFlags(
      this.inspectType,
      INSPECT_TYPE
    );
    if (md3RouteFlags.isGensha) {
      if (this.carSelection.jidoushaShubetsu) {
        if (this.hasTire(cate)) {
          cate.subItems.forEach(item => {
            item.inspectDescriptions.forEach(inspect => {
              let listVal = [] as InspectValueItem[];
              if (
                inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
              ) {
                listVal = WorkBuhinInspectionSelections.buildInspectionSelectionsTireValueList(
                  this.carSelection
                );
                const saveState =
                  WorkBuhinInspectionSelections.buildInspectionSelectionsInspectValueSaveState({
                    inspect,
                    listVal
                  });
                if (saveState.shouldSave) {
                  this.onConfirmValue(saveState.listVal, inspect, false);
                }
              }
            });
          });
        }
        if (this.hasGroundClr(cate)) {
          cate.subItems.forEach(item => {
            item.inspectDescriptions.forEach(inspect => {
              if (
                inspect.inspectValueViewType ==
                INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
              ) {
                const saiteiChijouKouState =
                  WorkBuhinInspectionSelections.buildInspectionSelectionsSaiteiChijouKouState({
                    inspect,
                    carSelection: this.carSelection,
                    groundClrViewType: INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
                  });
                if (saiteiChijouKouState.shouldSave) {
                  inspect.inspectResult = saiteiChijouKouState.inspectResult;
                  this.saveInspectItem(inspect);
                }
              }
            });
          });
        }
        if (this.carSelection.meterPanelAlert && this.hasSyncObd(cate)) {
          this.applyMeterPanelAlertToSyncObd(cate);
        }
      } else {
        this.reqService
          .getCarSelection(this.uketsukeExtendsId)
          .then((res: any) => {
            res.sknUketsukeExtendsId = this.uketsukeExtendsId;
            this.setStateCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.setDataFromMD3(cate);
          });
      }
    } else if (md3RouteFlags.isJizen && cate.subItems) { // 2021-10-07 sh add condition
      cate.subItems.forEach(item => {
        item.inspectDescriptions.forEach(inspect => {
          let listVal = [] as InspectValueItem[];
          if (inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
            listVal = WorkBuhinInspectionSelections.buildInspectionSelectionsTireValueList(
              this.carSelection
            );
            const saveState = WorkBuhinInspectionSelections.buildInspectionSelectionsInspectValueSaveState({
              inspect,
              listVal
            });
            if (saveState.shouldSave) {
              this.onConfirmValue(saveState.listVal, inspect, false);
            }
          } else if (
            inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
          ) {
            const saiteiChijouKouState =
              WorkBuhinInspectionSelections.buildInspectionSelectionsSaiteiChijouKouState({
                inspect,
                carSelection: this.carSelection,
                groundClrViewType: INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
              });
            if (saiteiChijouKouState.shouldSave) {
              inspect.inspectResult = saiteiChijouKouState.inspectResult;
              this.saveInspectItem(inspect);
            }
          } else if (
            inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SYNC_OBD &&
            this.carSelection.meterPanelAlert
          ) {
            const syncObdState = WorkBuhinInspectionSelections.buildInspectionSelectionsSyncObdState({
              inspect,
              carSelection: this.carSelection,
              syncObdViewType: INSPECT_VALUE_VIEW_TYPE.SYNC_OBD,
              circleValue: InspectButtonValue.CIRCLE,
              crossValue: InspectButtonValue.CROSS
            });
            if (syncObdState.shouldSave) {
              inspect.inspectResult = syncObdState.inspectResult;
              this.saveInspectItem(inspect);
              this.$forceUpdate();
            }
          }
        });
      });
    } else if (md3RouteFlags.isLegal56 && cate.subItems) {
      if (this.carSelection.meterPanelAlert && this.hasSyncObd(cate)) {
        this.applyMeterPanelAlertToSyncObd(cate);
      }
    }
  }

  getSyncObdInspects(cate: InspectGenshaCategory): InspectDescriptions[] {
    return cate.subItems.reduce((list: InspectDescriptions[], subCate) => {
      const syncObdInspects = subCate.inspectDescriptions.filter(
        inspect =>
          inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SYNC_OBD
      );
      return list.concat(syncObdInspects);
    }, []);
  }

  hasSyncObd(cate: InspectGenshaCategory): boolean {
    return this.getSyncObdInspects(cate).length > 0;
  }

  hasGroundClr(cate: InspectGenshaCategory): boolean {
    return cate.subItems.some(subCate =>
      subCate.inspectDescriptions.some(
        inspect =>
          inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
      )
    );
  }

  hasTire(cate: InspectGenshaCategory): boolean {
    return cate.subItems.some(subCate =>
      subCate.inspectDescriptions.some(
        inspect => inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
      )
    );
  }

  applyMeterPanelAlertToSyncObd(cate: InspectGenshaCategory) {
    let doForceUpdate = false;
    this.getSyncObdInspects(cate).forEach(inspect => {
      const syncObdState = WorkBuhinInspectionSelections.buildInspectionSelectionsSyncObdState({
        inspect,
        carSelection: this.carSelection,
        syncObdViewType: INSPECT_VALUE_VIEW_TYPE.SYNC_OBD,
        circleValue: InspectButtonValue.CIRCLE,
        crossValue: InspectButtonValue.CROSS
      });
      if (syncObdState.shouldSave) {
        inspect.inspectResult = syncObdState.inspectResult;
        this.saveInspectItem(inspect);
        doForceUpdate = true;
      }
    });
    if (doForceUpdate) {
      this.$forceUpdate();
    }
  }

  setSideSlipData(cate: InspectGenshaCategory) {
    if (
      WorkBuhinInspectionSelections.buildInspectionSelectionsMd3RouteFlags(this.inspectType, INSPECT_TYPE)
        .isLegal56 &&
      this.useLine &&
      this.sideSlipValue != null
    ) {
      cate.subItems.forEach(item => {
        item.inspectDescriptions.forEach(inspect => {
          const sideSlipState = WorkBuhinInspectionSelections.buildInspectionSelectionsSideSlipSaveState({
            inspect,
            sideSlipValue: this.sideSlipValue,
            sideSlipViewType: INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP
          });
          if (sideSlipState.shouldSave) {
            this.onConfirmValue(sideSlipState.listVal, inspect, true, false);
          }
        });
      });
    }
  }

  setCurrentData(gotop: boolean = true) {
    const currentDataState = WorkBuhinInspectionSelections.buildInspectionSelectionsCurrentDataState({
      data: this.data,
      apiPath: this.apiPath,
      activeCategory: this.activeCategory
    });
    if (currentDataState.shouldUpdate) {
      this.$set(this, "isOsusume", currentDataState.isOsusume);
      if (currentDataState.isOsusume) {
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        /**
         * const currentData = Array.from(
         *   this.data[this.apiPath][this.activeCategory].recommend[this.activeSubCategory].subItems
         * );
         * this.$set(this, "currentData", currentData);
         */
        this.setOsusumeCurrentData();
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      } else {
        this.loadData = currentDataState.loadData;
        this.$set(this, "currentData", currentDataState.currentData);
      }
      this.setDataFromMD3(currentDataState.activeCategoryData);
      /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [START] */
      // setTimeout(() => {
      //  this.scrollToFirstIncomplete();
      // }, 100);
      if (gotop) {
        setTimeout(() => {
          this.scrollToFirstIncomplete();
        }, 100);
      }
      /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [END] */
    }
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("activeCategory")
  onChangeActiveCategory() {
    if (this.loadData) {
      setTimeout(()=> {
        this.checkIsFreeSeibiDoesNotSelectingBuhin();
      }, 100);
    }
  }

  @Watch("loadData")
  onChangeLoadData() {
    if (this.loadData) {
      setTimeout(()=> {
        this.checkIsFreeSeibiDoesNotSelectingBuhin();
      }, 2000);
    }
  }

  checkIsFreeSeibiDoesNotSelectingBuhin() {
    if (this.currentData && this.currentData.length > 0) {
      let isFreeSeibiDoesNotSelectingBuhin = false;
      this.currentData.forEach((item: any) => {
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        // item.inspectDescriptions.forEach((inspect: any) => {
        //   if (inspect.seibiList) {
        //     const freeSeibiDoesNotSelectingBuhin = inspect.seibiList.filter((seibi : any) =>
        //       seibi.buhinSelected == 0 && seibi.discountWorkSelected == 1 
        //       && seibi.freeOfChargeBuhinList && seibi.freeOfChargeBuhinList.length > 1
        //     );
        //     if (freeSeibiDoesNotSelectingBuhin && freeSeibiDoesNotSelectingBuhin.length > 0) {
        //       isFreeSeibiDoesNotSelectingBuhin = true;
        //     }
        //   }
        // });
        if (item.inspectDescriptions && item.inspectDescriptions.length > 0) {
          item.inspectDescriptions.forEach((inspect: any) => {
            if (inspect.seibiList) {
              const freeSeibiDoesNotSelectingBuhin = inspect.seibiList.filter((seibi: any) =>
                seibi.buhinSelected == 0 && seibi.discountWorkSelected == 1 
                && seibi.freeOfChargeBuhinList && seibi.freeOfChargeBuhinList.length > 1
              );
              if (freeSeibiDoesNotSelectingBuhin && freeSeibiDoesNotSelectingBuhin.length > 0) {
                isFreeSeibiDoesNotSelectingBuhin = true;
              }
            }
          });
        }
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      });
      if (isFreeSeibiDoesNotSelectingBuhin) {
        this.$refs.freeSeibiNotSectingBuhinDialog.onOpen();
      }
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  getIndex(parent: number, child: number) {
    let res = 0;
    for (let i = 0; i < parent; i++) {
      res += this.currentData[i].inspectDescriptions.length;
    }
    return res + child;
  }

  isActive(i: number) {
    return this.activeCategory == i;
  }

  // onCheckAll(index: number, data: { isActive: boolean; value: number }) {
  //   const start = this.getIndex(index, 0);
  //   const end = start + this.currentData[index].inspectDescriptions.length - 1;
  //   let c = 0;
  //   for (let i = start; i <= end; i++) {
  //     let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
  //     const isChange = buttongroup.setActive({
  //       isActive: data.isActive,
  //       value: data.value,
  //       isAll: true
  //     });
  //     if (isChange) {
  //       this.saveInspectItem(this.currentData[index].inspectDescriptions[c]);
  //     }
  //     c++;
  //   }
  // }
  onCheckAll(index: number, data: { isActive: boolean; value: number }) {
    const start = this.getIndex(index, 0);
    const end = start + this.currentData[index].inspectDescriptions.length - 1;
    // let c = 0;
    let nChange = 0;
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
    let objForSave: any = [];
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    for (let i = start; i <= end; i++) {
      let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
      const isChange = buttongroup.setActive({
        isActive: data.isActive,
        value: data.value,
        isAll: true
      });
      if (isChange) {
        nChange++;
      }
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      objForSave.push({item: this.currentData[index].inspectDescriptions[i-start], isChange: isChange});
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
      // if (isChange) {
      //   this.saveInspectItem(this.currentData[index].inspectDescriptions[c]);
      // }
      // c++;
    }
    if (nChange > 0) {
      this.activeSubCateIndex = index;
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      // this.saveSubItem(this.currentData[index]);
      this.saveSubItem(objForSave, index);
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    }
  }

  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
  /**
   * saveCurrentData() {
   *   let objForSave: InspectGenshaSubItem[] = this.utils.deepCopy(this.currentData);
   *   let arrInspect: any = [];
   *   const promise = objForSave.map(
   *     (item: InspectGenshaSubItem, iSubcate: number) => {
   *       item.inspectDescriptions.map(
   *         (inspect: InspectDescriptions, iItem: number) => {
   *           this.keepInspectRef(inspect, iSubcate, iItem);
   *           arrInspect.push(this.removeInspectParam(inspect, false));
   *           return inspect;
   *         }
   *       );
   *       return item;
   *     }
   *   );
   *   Promise.all(promise).then(() => {
   *     this.callAPISaveMultipleItems(arrInspect);
   *   });
   * }
   */
  saveCurrentData(objForSave: any) {
    let arrInspect: any = [];
    const promise = objForSave.map(
      (obj: any[], iSubcate: number) => {
        if (obj[0] && obj[0].length > 0) {
          obj[0].map(
            (data: any, iItem: number) => {
              let inspect = data.item;
              if (data.isChange) {
                this.keepInspectRef(inspect, iSubcate, iItem);
                /** コピーモードで、呼び出す。オリジナルで処理させると、seibiListが消え、おかしなことになる。 */
                arrInspect.push(this.removeInspectParam(inspect, true));
              }
              return data;
            }
          );
          return obj;
        }
      }
    );
    Promise.all(promise).then(() => {
      this.callAPISaveMultipleItems(arrInspect);
    });
  }

  setActiveForPassAllCategory(index: number) {
    let promise = new Promise((resolve, reject) => {
      const start = this.getIndex(index, 0);
      const end = start + this.currentData[index].inspectDescriptions.length - 1;
      let objForSave: any = [];
      for (let i = start; i <= end; i++) {
        let buttongroup = this.$refs.buttonGroup[i] as any;
        const isChange = buttongroup.setActive({
          isActive: true,
          value: InspectButtonValue.CIRCLE,
          isAll: true
        });
        // ここで、変更だけにすると、keepInspectRefで、位置を覚えるときに、ズレてしまうので、全ての結果を返すようにする。
        // 変更だけで、絞り込むのは、keepInspectRefを呼ぶタイミングにする。
        objForSave.push({item: this.currentData[index].inspectDescriptions[i-start], isChange: isChange});
      }
      resolve([objForSave, index]);
    });
    return promise;
  }
  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

  removeInspectParam(inspectItem: InspectDescriptions, copy: boolean = true) {
    this.setSaving(inspectItem.sknInspectDescriptionId);
    let objForSave = {} as InspectDescriptions;
    if (copy) {
      objForSave = this.utils.deepCopy(inspectItem);
    } else {
      objForSave = inspectItem;
    }
    WorkBuhinInspectionSelections.removeInspectionSelectionsInspectViewParams(objForSave);
    // objForSave.inspectResult = 0;
    if (objForSave.inspectResult == InspectButtonValue.CIRCLE) {
      let oldWorkBuhinSelected = objForSave.workBuhinSelected;
      objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      if (oldWorkBuhinSelected == 0) {
        objForSave.seibiList = [];
      } else {
        if (objForSave.manualSeibiList.length > 0) {
          const manualSeibiList = this.utils.deepCopy(objForSave.manualSeibiList);
          objForSave.manualSeibiList = [];
          manualSeibiList.forEach((seibi: any) => {
            const id: any = seibi.seibiId;
            this.reqService.deleteManualSeibi({
              sknUketsukeManualSeibiId: id,
              uketsukeExtendsId: this.uketsukeExtendsId
            });
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
            delete seibi.disabledSave;
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
            return seibi;
          });
        }
        const subCateIndex = this.activeSubCateIndex;
        objForSave.seibiList.forEach((seibi: Work) => {
          const buhinSelected = seibi.buhinSelected;
          seibi.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
          if (
            buhinSelected === STATUS_SELECT_WORK_BUHIN.Done &&
            !seibi.disabledSave
          ) {
            let listInspect = this.currentData[
              subCateIndex
            ].inspectDescriptions.filter(
              inspect =>
                inspect.sknInspectDescriptionId !=
                objForSave.sknInspectDescriptionId
            );
            this.service.autoSetDuplicateSeibi(listInspect, seibi);
          }

          if (seibi.manualBuhinList.length > 0) {
            seibi.manualBuhinList.forEach(buhin => {
              if (buhin.buhinId) {
                this.reqService.deleteManualBuhin(buhin.buhinId);
              }
              /** 2022-08-05 sh #8018(BQR1031) add isDelete to manual's buhin. [START] */
              if (buhin.id) {
                buhin.isDelete = 1;
              }
              /** 2022-08-05 sh #8018(BQR1031) add isDelete to manual's buhin. [END] */
            });
          }
          if (seibi.buhinList.length > 0) {
            seibi.buhinList.forEach(buhin => {
              if (buhin.id) {
                buhin.isDelete = 1;
              }
            });
          }
        });
      }
    }

    /** 2021-12-01 sh #7587 change check seibiIds. [START] */
    /** FakeDoneは、共通の整備が他で、選択済みな状態。保存するときは、Doneにする。 */
    if (objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.FakeDone) {
       objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
     }
    /** 2021-12-01 sh #7587 change check seibiIds. [END] */
    for (let i = objForSave.seibiList.length - 1; i >= 0; i--) {
      if (
        objForSave.seibiList[i].buhinSelected ==
          STATUS_SELECT_WORK_BUHIN.Initial &&
        objForSave.seibiList[i].seibiId == null
      ) {

        objForSave.seibiList.splice(i, 1);
      } else {
        if (objForSave.seibiList[i].disabledSave) {
          /** 2021-09-09 sh #7393 if it has seibi of recommend that it does not link to inspect, save it. [START] */
          // objForSave.seibiList.splice(i, 1);
          if (objForSave.sknUketsukeInspectId == null 
            && objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
            /** 2021-11-29 sh #7579 if gensha or legal57, run 'splice'. [START] */
            /** 点検と紐づいていない整備が選択済みだった場合、おすすめ整備となるので、削除せずに紐づけてあげる */
            // delete objForSave.seibiList[i].disabledSave;
            if (this.routeService.shouldRemoveUnlinkedDisabledSaveSeibi(
              objForSave.seibiList[i]
            )) {
              objForSave.seibiList.splice(i, 1);
            } else {
              delete objForSave.seibiList[i].disabledSave;
            }
            /** 2021-11-29 sh #7579 if gensha or legal57, run 'splice'. [END] */
          } else {
            objForSave.seibiList.splice(i, 1);
          }
          /** 2021-09-09 sh #7393 if it has seibi of recommend that it does not link to inspect, save it. [END] */
        } else {
          const buhinList = objForSave.seibiList[i].buhinList.filter(
            buhin => buhin.quantity > 0
          );
          objForSave.seibiList[i].buhinList = buhinList;
          if (objForSave.seibiList[i].hasOwnProperty("disabledSave")) {
            delete objForSave.seibiList[i].disabledSave;
          }
          if (objForSave.seibiList[i].hasOwnProperty("ignoreSeibi")) {
            delete objForSave.seibiList[i].ignoreSeibi;
          }
        }
      }
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    if (objForSave.manualSeibiList.length > 0) {
      objForSave.manualSeibiList.forEach((seibi: any) => {
        delete seibi.disabledSave;
        return seibi;
      });
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    return objForSave;
  }

  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
  /**
   *   saveSubItem(subItem: InspectGenshaSubItem) {
   *     let subItemForSave = this.utils.deepCopy(subItem);
   *     let items: any = [];
   *     // if (
   *     //   subItemForSave.inspectDescriptions.every(
   *     //     (item: any) => item.status == InspectButtonStatus.INCOMPLETE
   *     //   )
   *     // ) {
   *     //   return false;
   *     // }
   *     subItemForSave.inspectDescriptions.forEach(
   *       (inspect: InspectDescriptions, i: number) => {
   *         this.keepInspectRef(inspect, this.activeSubCateIndex, i);
   *         items.push(this.removeInspectParam(inspect, false));
   *         // this.removeFromNotSavedList(inspect);
   *       }
   *     );
   *     if (items.length > 0) {
   *       if (this.tempListSave.length > 0) {
   *         this.clearTimerSave();
   *         items = [...items, ...this.tempListSave];
   *       }
   *       this.callAPISaveMultipleItems(items, false);
   *     }
   *   }
   */
  saveSubItem(subItems: any[], subCateIndex: any = this.activeSubCateIndex) {
    let subItemForSave = this.utils.deepCopy(subItems);
    let items: any = [];

    const promise = subItemForSave.map(
      (data: any, i: number) => {
        let inspect: InspectDescriptions = data.item;
        if (data.isChange) {
          this.keepInspectRef(inspect, subCateIndex, i);
          items.push(this.removeInspectParam(inspect, false));
        }
        return data;
      }
    );
    Promise.all(promise).then(() => {
      if (items.length > 0) {
        if (this.tempListSave.length > 0) {
          this.clearTimerSave();
          items = [...items, ...this.tempListSave];
        }
        this.callAPISaveMultipleItems(items, false);
      }
    });
  }
  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

  callAPISaveMultipleItems(items: any, updateData: boolean = true) {
    if (this.isSaving) {
      if (this.tempWaitSave == null) {
        this.tempWaitSave = [];
      }
      this.tempWaitSave = [...this.tempWaitSave, ...items];
      this.isCallSaveWhenSaving = true;
    } else {
      this.isSaving = true;
      let data: any = this.routeService.buildInspectSavePayload(items);
      this.routeService.saveInspect(data).then( // sendSocket:ソケット仮04
        (res: any) => {
          this.$set(this, "isSaving", false);
          this.arrStatus = [];
          if (this.routeService.hasRouteBody(res)) {
            this.isSocket = true;
            this.updateInspectList(res.body, true);
            const pendingSaveState =
              WorkBuhinInspectionSelections.resolveInspectionSelectionsPendingInspectSaveState({
                isCallSaveWhenSaving: this.isCallSaveWhenSaving,
                tempWaitSave: this.tempWaitSave
              });
            this.isCallSaveWhenSaving =
              pendingSaveState.isCallSaveWhenSaving;
            if (pendingSaveState.shouldCallPendingSave) {
              this.callAPISaveMultipleItems(
                pendingSaveState.pendingItems,
                updateData
              );
              this.tempWaitSave = pendingSaveState.tempWaitSave;
            } else {
              this.tempListSave = [];
              // if (updateData) {
              //   this.data = res.body;
              //   this.addStatus();
              // }
            }
          }
        },
        error => {
          this.$set(this, "isSaving", false);
          console.error("error", error);
          const errorState =
            WorkBuhinInspectionSelections.buildInspectionSelectionsMultipleInspectSaveErrorState({
              data,
              apiPath: this.apiPath
            });
          this.$notify.error({
            title: "エラー",
            message: errorState.message
          });
          this.tempListSave = errorState.tempListSave;
          this.arrStatus = errorState.arrStatus;
          if (errorState.shouldInitPage) {
            this.initPage();
          }
        }
      );
    }
  }

  // removeFromNotSavedList(inspectItem: InspectDescriptions) {
  //   let indexNotSaved = this.listNotSavedId.indexOf(
  //     inspectItem.sknInspectDescriptionId
  //   );
  //   if (indexNotSaved > -1) {
  //     this.listNotSavedId.splice(indexNotSaved, 1);
  //   }
  // }

  getIsSocket() {
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [START] */
    // return this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    let isSocket = this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    if (isSocket == 0) {
      if (this.activeInspect && this.activeInspect.buhinList) {
        if (this.activeInspect.buhinList.length == 0 || this.activeInspect.buhinList.length == 1) {
          isSocket = 1;
        }
      }
      if (this.activeInspect && this.activeInspect.osusumeBuhinList) {
        if (this.activeInspect.osusumeBuhinList.length == 0 || this.activeInspect.osusumeBuhinList.length == 1) {
          isSocket = 1;
        }
      }
    }
    return isSocket;
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [END] */
  }

  getObjForSave() {
    return this.routeService.buildInspectSavePayload(
      this.utils.deepCopy(this.tempListSave)
    );
  }

  saveInspectItem(inspectItem: InspectDescriptions) {
    let objForSave: InspectDescriptions = this.removeInspectParam(inspectItem);
    if (this.isSaving) {
      // this.tempWaitSave = this.utils.deepCopy(inspectItem);
      // this.timerSaving = setTimeout(() => {
      //   this.saveInspectItem(inspectItem);
      // }, 1000);
      if (this.tempWaitSave == null) {
        this.tempWaitSave = [];
      }
      this.tempWaitSave.push(objForSave);
      this.isCallSaveWhenSaving = true;
      return;
    } else {
      this.tempWaitSave = null;
    }
    // if (inspectItem.status == InspectButtonStatus.COMPLETED || forceSave) {
    this.clearTimerSave();
    // this.removeFromNotSavedList(inspectItem);
    this.arrStatus.push(inspectItem.status || 0);
    this.tempListSave = WorkBuhinInspectionSelections.upsertInspectionSelectionsInspectSaveQueue(
      this.tempListSave,
      objForSave
    );
    this.saveSknSaiteiChijouKou(inspectItem);
    this.callAPISave(inspectItem);
  }

  callAPISave(inspectItem: InspectDescriptions) {
    let apiPath = this.apiPath;
    const routeService = this.routeService;
    this.timerSave = setTimeout(() => {
      if (this.tempListSave.length > 0) {
        const isOneSocket = this.tempListSave.length > 1;
        let data: any = this.getObjForSave();
        this.isSaving = true;
        this.tempListSaving = this.utils.deepCopy(this.tempListSave);
        this.tempListSave = [];
        this.arrStatus = [];
        routeService.saveInspect(data).then(
          (res: any) => {
            if (res.status == 200 && this.routeService.hasRouteBody(res)) {
              /** 2021-12-01 sh #7587 change check seibiIds. [START] */
              const promise = this.getSelectingSeibiIdsPM(this.uketsukeExtendsId);
              Promise.all([promise]).then((val: any) => {
                const resSeibiIds: any = val[0];
                this.setStateSeibiDetailIds(resSeibiIds);
              });
              /** 2021-12-01 sh #7587 change check seibiIds. [END] */
              this.$set(this, "isSaving", false);
              this.updateInspectList(res.body, isOneSocket);
              const pendingSaveState =
                WorkBuhinInspectionSelections.resolveInspectionSelectionsPendingInspectSaveState({
                  isCallSaveWhenSaving: this.isCallSaveWhenSaving,
                  tempWaitSave: this.tempWaitSave
                });
              this.isCallSaveWhenSaving =
                pendingSaveState.isCallSaveWhenSaving;
              if (pendingSaveState.shouldCallPendingSave) {
                this.callAPISaveMultipleItems(pendingSaveState.pendingItems);
                this.tempWaitSave = pendingSaveState.tempWaitSave;
              }
              const tempListSavingState =
                WorkBuhinInspectionSelections.resolveInspectionSelectionsTempListSavingState({
                  apiPath,
                  currentApiPath: this.apiPath,
                  tempListSaving: this.tempListSaving
                });
              if (tempListSavingState.shouldReturn) {
                return;
              }
              if (tempListSavingState.shouldClearTempListSaving) {
                this.tempListSaving = [];
              }
            }
          },
          error => {
            console.error("error", error);
            this.$set(this, "isSaving", false);
            const errorState = WorkBuhinInspectionSelections.buildInspectionSelectionsInspectSaveErrorState(
              this.tempListSaving
            );
            if (errorState.notifyNames.length > 0) {
              this.$notify.error({
                title: "エラー",
                message: errorState.notifyNames.join()
              });
            }
            this.tempListSaving = errorState.tempListSaving;
            if (errorState.shouldClearCurrentData) {
              setTimeout(() => {
                this.currentData = [];
              }, 0);
            }
            if (errorState.shouldInitPage) {
              this.initPage();
            }
          }
        );
      }
    }, 800);
  }

  saveSknSaiteiChijouKou(inspectItem: InspectDescriptions) {
    if (
      inspectItem.inspectValueViewType ==
      INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
    ) {
      let result = inspectItem.inspectResult;
      if (result == 3) {
        result = 2;
      }
      if (result != this.carSelection.sknSaiteiChijouKou) {
        this.carSelection.sknSaiteiChijouKou = result;
        this.reqService.saveCarSelection(this.carSelection);
      }
    }
  }

  clearTimerSave() {
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
  }

  findInspectIndex(list: InspectGenshaSubItem, id: number) {
    return WorkBuhinInspectionSelections.findInspectionSelectionsInspectDescriptionIndex(list, id);
  }

  onError(res: any) {
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
    this.loading = false;
  }

  onSave() {
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  onRegister() {
    this.$emit("saveSpentTime");
    let status = "0";
    const categories = this.routeService.extractCurrentCategories(this.data);
    status = this.routeService.getRegisterStatus(categories, this.service);
    if (this.routeService.shouldUpdateUketsukeExtendsOnRegister()) {
      this.reqService.updateTSknUketsukeExtends(this.uketsukeExtendsId).then(
        (res: any) => {
        },
        (err: any) => {
        }
      );
    }
    this.$emit("onregister", { pageName: this.$route.name, status });
  }

  onInspectBtnChange(value: number, item: InspectDescriptions) {
    this.service.setInspectResult(value, item);
    this.changeStatus(item);
  }

  changeStatus(item: InspectDescriptions, checkCate?: boolean, isInit?: boolean) {
    this.service.changeStatus(item, isInit);
    if (checkCate !== false) {
      this.changeCateStatus();
    }
  }

  changeCateStatus() {
    let nItem = 0;
    let sumStatus = 0;
    if (this.currentData && this.currentData.length > 0) {
      nItem = this.currentData.reduce(
        (sum, cur: InspectGenshaSubItem) =>
          sum + cur.inspectDescriptions.length,
        0
      );
      this.currentData.forEach((item: InspectGenshaSubItem) => {
        if (item.inspectDescriptions && item.inspectDescriptions.length > 0) {
          sumStatus += item.inspectDescriptions.reduce(
            (sum, cur: InspectDescriptions) =>
              sum + (cur.status ? cur.status : 0),
            0
          );
        }
      });
      // console.log("sumStatus", sumStatus, nItem)
      this.setCateStatus(sumStatus, nItem);
    }
  }

  setCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectGenshaCategory
  ) {
    if (cate == null) {
      cate = this.routeService.getCurrentCategory(
        this.data,
        this.activeCategory
      );
    }
    if (cate) {
      if (sumStatus == 0) {
        cate.status = InspectButtonStatus.NONE;
      } else if (sumStatus == nItem * InspectButtonStatus.COMPLETED) {
        cate.status = InspectButtonStatus.COMPLETED;
      } else {
        cate.status = InspectButtonStatus.INCOMPLETE;
      }
    }
  }

  isDisabled(item: InspectDescriptions) {
    return this.service.isDisabled(item);
  }

  isComplete(item: any) {
    return this.service.isComplete(item);
  }

  isIncomplete(item: any) {
    return this.service.isIncomplete(item);
  }

  goTop() {
    let wrap = document.querySelector(".select-item-wrap");
    if (wrap) {
      wrap.scrollTop = 0;
    }
  }

  goBackCate() {
    // this.activeCategory--;
    this.changeCategory(this.activeCategory - 1);
  }

  get showBtnBack() {
    if (this.activeCategory > 0) {
      return true;
    }
    return false;
  }

  // get backCate() {
  //  if (this.showBtnBack) {
  //    return this.data[this.apiPath][this.activeCategory - 1]
  //      .sknInspectCategoryNm;
  //  }
  //  return "";
  // }

  goNextCate() {
    if (
      this.activeCategory <
        this.routeService.getCurrentCategoryCount(this.data) - 1
    ) {
      // this.activeCategory++;
      this.changeCategory(this.activeCategory + 1);
    }
  }

  get showBtnNext() {
    if (
      this.routeService.hasCurrentCategories(this.data) &&
      this.activeCategory <
        this.routeService.getCurrentCategoryCount(this.data) - 1
    ) {
      return true;
    }
    return false;
  }

  // get nextCate() {
  //  if (this.showBtnNext) {
  //    return this.data[this.apiPath][this.activeCategory + 1]
  //      .sknInspectCategoryNm;
  //  }
  //  return "";
  // }

  onClickCategory(e: any, index: number, cate: InspectGenshaCategory) {
    if (index != this.activeCategory) {
      this.changeCategory(index);
    } else {
      this.dblclickCategory(index, cate);
    }
  }

  changeCategory(i: number) {
    const changeState = WorkBuhinInspectionSelections.buildInspectionSelectionsCategoryChangeState({
      activeCategory: this.activeCategory,
      nextCategory: i,
      categories: this.routeService.extractCurrentCategories(this.data),
      apiPath: this.apiPath,
      inspectType: this.inspectType,
      jizenType: INSPECT_TYPE.JIZEN,
      lastSelectedSubPos: this.getLastSelectedSubPos()
    });
    if (changeState.shouldChange) {
      this.activeCategory = changeState.activeCategory;
      this.activeSubCategory = changeState.activeSubCategory;
      this.currentData = changeState.currentData;
      setTimeout(() => {
        this.setCurrentData();
      }, 0);
      /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
      /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
      this.setRouteInfo({ data: changeState.routeInfo, index: this.inspectType });
      /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
      this.scrollToFirstIncomplete();
    }
  }

  dblclickCategory(index: number, cate: InspectGenshaCategory) {
    if (this.$refs.buttonGroup.every((e: any) => e.value)) {
      return;
    }
    const status = cate.status;
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
    /**
     * this.service.setPassAllCategory(
     *   index,
     *   this.activeCategory,
     *   this.$refs.buttonGroup,
     *   cate
     *   // (isChange: boolean, subCateIndex: number, index: number) => {
     *   // if (isChange) {
     *   //   this.saveInspectItem(
     *   //     this.currentData[subCateIndex].inspectDescriptions[index]
     *   //   );
     *   // }
     *   // }
     * );
     */
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

    if (status != InspectButtonStatus.COMPLETED) {
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      // this.saveCurrentData();
      let copyCurrentData = this.utils.deepCopy(this.currentData);
      let arrPromises: any[] = Array();
      for (let index2=0; index2 < copyCurrentData.length; index2++) {
        let promise = this.setActiveForPassAllCategory(index2);
        if (promise) {
          arrPromises.push(promise);
        }
      }

      Promise.all(arrPromises).then((ret)=> {
        if (ret) {
          console.log(ret);
          this.saveCurrentData(ret);
        }
      }, err => {});
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    }
  }

  showWork(event: any, item: any, subCateIndex: number, itemIndex: number) {
    const openState = WorkBuhinInspectionSelections.buildInspectionSelectionsWorkOpenState(
      item,
      subCateIndex
    );
    Object.assign(item, openState.itemState);
    this.activeInspect = openState.activeInspect;
    this.activeSubCateIndex = openState.activeSubCateIndex;
    this.keepInspectRef(item, subCateIndex, itemIndex);
    /* 2024-06-01 yd #8864 [START] */
    /** 2021-09-24 sh #7428 improved initial selecting seibi. [START] */
    // setTimeout(() => {
    //   this.$refs.workBuhinDialog.initialSelectSeibi();
    // }, 100);
    /** 2021-09-24 sh #7428 improved initial selecting seibi. [END] */
    /* 2024-06-01 yd #8864 [END] */
  }

  onConfirmChangeInspect() {
    this.$refs.buttonGroup[this.buttonIndex].setActive({
      isActive: true,
      value: InspectButtonValue.CIRCLE,
      isAll: false
    });
    const inspection = this.utils.deepCopy(this.tempInspect);
    const ids = inspection.seibiList.map((e: any) => e.seibiDetailId);
    this.removeSeibiId({ ids, type: this.tempInspect.sknInspectType });
    this.service.setInspectResult(InspectButtonValue.CIRCLE, this.tempInspect);
    this.changeStatus(this.tempInspect);
    this.saveInspectItem(this.tempInspect);
    this.$refs.confirmDialog.onClose();

    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [START] */
    if (this.routeService.shouldAutoResetJizenRecommend()) {
      // console.log("inspectionSelections.onInspectBtnClick this.data.jizen => ", this.tempInspect);
      if (this.tempInspect.inspectResult == InspectButtonValue.CIRCLE) {
        this.service.autoResetSameRecommendSeibi4Jizen(
          this.routeService.extractCurrentCategories(this.data),
          this.tempInspect
        );
      }
    }
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [END] */
  }
  onCancelChangeInspect() {
    if (this.tempSaveRef[this.tempInspect.sknInspectDescriptionId]) {
      delete this.tempSaveRef[this.tempInspect.sknInspectDescriptionId];
    }
    this.$refs.confirmDialog.onClose();
  }

  askConfirmChange(item: InspectDescriptions, i: number, j: number) {
    this.$refs.confirmDialog.onOpen();
    this.tempInspect = item;
    this.buttonIndex = this.getIndex(i, j);
    this.keepInspectRef(item, i, j);
    this.activeSubCateIndex = i;
  }

  onConfirmBuhin(data: {
    inspectItem: InspectDescriptions;
    seibi: Work;
    notManual: boolean;
  }) {
    this.changeStatus(this.activeInspect);
    const confirmState = WorkBuhinInspectionSelections.buildInspectionSelectionsConfirmBuhinState({
      currentData: this.currentData,
      activeSubCateIndex: this.activeSubCateIndex,
      inspectItem: data.inspectItem,
      tireViewType: INSPECT_VALUE_VIEW_TYPE.TIRE,
      notManual: data.notManual,
      inspectType: this.inspectType,
      jizenType: INSPECT_TYPE.JIZEN
    });
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [START] */
    // console.log("inspectionSelections.onConfirmBuhin data => ", this.data.jizen);
    if (this.routeService.shouldAutoSetJizenRecommend(data.notManual)) {
      this.service.autoSetSameRecommendSeibi4Jizen(
        this.routeService.extractCurrentCategories(this.data),
        data.inspectItem,
        data.seibi,
        1
      );
    }
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [END] */
    if (confirmState.shouldAutoSetDuplicateSeibi) {
      this.service.autoSetDuplicateSeibi(confirmState.listInspect, data.seibi);
    }
  }

  onCallbackDeleteManualSeibi(sknUketsukeInspectId: any) {
    if (sknUketsukeInspectId) {
      this.changeStatus(this.activeInspect);
      // sendSocket:ソケット仮04
      this.reqService.sendSocket(this.uketsukeExtendsId, sknUketsukeInspectId);
    }
  }

  onCloseBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    const closeState = WorkBuhinInspectionSelections.buildInspectionSelectionsCloseState(
      event,
      this.activeInspect
    );
    if (closeState.shouldSave) {
      this.isSocket = closeState.isSocket;
      this.changeStatus(closeState.activeInspect);
      this.saveInspectItem(closeState.activeInspect);
    }
    this.$set(this, "activeInspect", {});
  }

  closeDialogWork() {
    if (Object.keys(this.activeInspect).length > 0) {
      this.activeInspect.showWork = false;
    }
  }

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  // buttonLabel(inspect: InspectDescriptions) {
  buttonLabel(inspect: any) {
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  //  if (
  //    inspect.seibiList && inspect.seibiList.length == 0 
  //    && inspect.manualSeibiList && inspect.manualSeibiList.length == 0
  //  ) {
  //    return "選択なし";
  //  }
    const label = WorkBuhinInspectionSelections.getInspectionSelectionsWorkButtonLabel(inspect);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  //  if (!inspect.workBuhinSelected && inspect.sknInspectType == 2 && inspect.buhinSelected == 0) {
  //    return "選択";
  //  }
  //  if (!inspect.workBuhinSelected && inspect.sknInspectType == 4 && inspect.buhinSelected == 0) {
  //    return "選択";
  //  }
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    return label;
  }

  buttonOsusumeLabel(inspect: any) {
    return WorkBuhinInspectionSelections.getInspectionSelectionsOsusumeWorkButtonLabel(inspect);
  }

  openValueDialog(item: InspectDescriptions, i: number, j: number) {
    this.activeSubCateIndex = i;
    this.service
      .findInspectionByValueViewType(
        this.currentData,
        item.inspectValueViewType
      )
      .then(
        (data: any) => {
          if (data && data.list) {
            this.tempBtnIndexList = [];
            data.index.forEach((resItem: any) => {
              resItem.listIndex.forEach((keyJ: number) => {
                this.tempBtnIndexList.push(this.getIndex(resItem.i, keyJ));
              });
            });
            this.$set(this, "inspectList", data.list);
            this.$set(item, "showValue", true);
          }
        },
        (err: any) => {
          this.$set(this, "inspectList", []);
          this.$set(this, "tempBtnIndexList", []);
          this.$set(item, "showValue", true);
          this.tempBtnIndex = this.getIndex(i, j);
          this.keepInspectRef(item, i, j);
        }
      );
  }

  onConfirmValue(
    inspectValueList: InspectValueItem[],
    item: InspectDescriptions,
    isUserInput: boolean = true,
    saveSideSlip: boolean = true
  ) {
    item.inspectValueList = inspectValueList;
    const isTire = item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE;
    const oldStatus = item.status;
    this.service.setButtonAfterInputValue(
      item,
      this.tempBtnIndex,
      this.$refs.buttonGroup,
      this.carSelection
    );
    this.tempBtnIndex = -1;
    this.changeStatus(item);
    if (
      isUserInput &&
      item.inspectValueViewType != INSPECT_VALUE_VIEW_TYPE.BOOTS
    ) {
      this.service.autoSetInspectValueSameCommentId(
        this.routeService.extractCurrentCategories(this.data),
        item,
        this.callbackAutoInspectValue
      );
    }
    if (isUserInput) {
      this.isSocket = true;
      if (isTire) {
        if (inspectValueList.length == 4) {
          this.carSelection.fLeftTireNokorimizo =
            inspectValueList[0].inspectValue;
          this.carSelection.fRightTireNokorimizo =
            inspectValueList[1].inspectValue;
          this.carSelection.rLeftTireNokorimizo =
            inspectValueList[2].inspectValue;
          this.carSelection.rRightTireNokorimizo =
            inspectValueList[3].inspectValue;
        }
        this.reqService.saveCarSelection(this.carSelection);
      }
      if (
        saveSideSlip &&
        this.useLine &&
        item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP &&
        this.inspectLineList.length > 0
      ) {
        this.inspectLineList[0].inspectValue = inspectValueList[0].inspectValue;
        this.reqService.saveInspectLineResult(this.inspectLineList[0]);
        this.setSideSlip(this.inspectLineList[0].inspectValue);
      }
    }
    this.saveInspectItem(item);
  }

  callbackAutoInspectValue(inspect: InspectDescriptions, i: number, j: number) {
    let btnIndex = this.getIndex(i, j);
    this.service.setButtonAfterInputValue(
      inspect,
      btnIndex,
      this.$refs.buttonGroup,
      this.carSelection
    );
    this.saveInspectItem(inspect);
  }
  hasValue(inspect: InspectDescriptions) {
    if (
      inspect.inspectValueList != null &&
      inspect.inspectValueList.length > 0 &&
      inspect.inspectValueList.every(
        (val: InspectValueItem) =>
          !(val.inspectValue == null || val.inspectValueStr == null 
          || val.inspectValue == '' || val.inspectValueStr == '')
      )
    ) {
      return "green";
    } else if (this.isIncomplete(inspect)) {
      return "red";
    }
    return "normal";
  }
  hasValueWork(inspect: InspectDescriptions) {
    return WorkBuhinInspectionSelections.getInspectionSelectionsWorkValueClass({
      selectedValue: inspect.workBuhinSelected,
      isIncomplete: this.isIncomplete(inspect)
    });
  }

  updateInspectList(data: any, sendOneSocket: boolean = false) {
    let sendSocket = true;
    const inspectList = this.routeService.extractSavedInspectDescriptions(data);
    if (inspectList.length > 0) {
      inspectList.forEach((itemRes: any) => {
        if (this.tempSaveRef[itemRes.sknInspectDescriptionId]) {
          const { cateIndex, subCateIndex, itemIndex } = this.tempSaveRef[
            itemRes.sknInspectDescriptionId
          ];
          delete this.tempSaveRef[itemRes.sknInspectDescriptionId];
          const inspectRef = this.routeService
            .getCurrentCategory(this.data, cateIndex)
            .subItems[subCateIndex]
            .inspectDescriptions[itemIndex];
          const showValue = inspectRef.showValue;
          const showWork = inspectRef.showWork;
          let seibiList = inspectRef.seibiList;
          if (itemRes.seibiList.length > 0) {
            seibiList.forEach((seibi: any, index: number) => {
              const seibiRes = itemRes.seibiList.find(
                (e: any) =>
                  e.seibiDetailId == seibi.seibiDetailId &&
                  e.workCd == seibi.workCd
              );
              if (seibiRes) {
                if (itemRes.inspectResult == InspectButtonValue.CIRCLE) {
                  seibiRes.seibiId = null;
                  seibiRes.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
                  seibiRes.manualBuhinList = [];
                  seibiRes.buhinList = seibi.buhinList.map((buhin: any) => {
                    let buhinMap = { ...buhin };
                    buhinMap.id = null;
                    buhinMap.isDelete = 0;
                    return buhinMap;
                  });
                }
                seibiList[index] = seibiRes;
              }
            });
          }
          if (itemRes.inspectResult == InspectButtonValue.CIRCLE) {
            itemRes.manualSeibiList = [];
          }
          itemRes.seibiList = seibiList;
          this.changeStatus(itemRes);
          if (sendSocket) {
            // 整備項目が実施扱いの時別画面への伝播も行う(FEでは未実施でもBEが実施扱いの場合があるのでその時も伝播)
            if (
              sendSocket &&
              (this.isSocket ||
                (!sendOneSocket &&
                  (itemRes.status == InspectButtonStatus.COMPLETED ||
                  itemRes.workBuhinSelected == InspectButtonStatus.COMPLETED))) &&
              itemRes.sknUketsukeInspectId
            ) {
              // sendSocket:ソケット仮04
              this.reqService.sendSocket(
                this.uketsukeExtendsId,
                itemRes.sknUketsukeInspectId
              );
            }
            if (sendOneSocket) {
              this.isSocket = false;
            }
          }
          this.$set(
            this.routeService.getCurrentCategory(this.data, cateIndex)
              .subItems[subCateIndex].inspectDescriptions,
            itemIndex,
            { ...itemRes, showWork, showValue, isSaving: false }
          );
          // console.log(this.currentData[subCateIndex].inspectDescriptions[itemIndex]);
        } else if (this.isSocket) {
          if (this.routeService.shouldClearSocketAfterInspectSave(sendOneSocket)) {
            this.isSocket = false;
            this.inspectList.forEach(
              (inspect: InspectDescriptions, i: number) => {
                inspect.isSaving = false;
              }
            );
          }
          // sendSocket:ソケット仮04
          this.reqService.sendSocket(
            this.uketsukeExtendsId,
            itemRes.sknUketsukeInspectId
          );
        }
      });
    }
  }

  onInspectBtnClick(item: any, subCateIndex: number, itemIndex: number) {
    item.isSaving = true;
    this.keepInspectRef(item, subCateIndex, itemIndex);
    this.saveInspectItem(item);
  }

  keepInspectRef(item: any, subCateIndex: number, itemIndex: number) {
    this.tempSaveRef[item.sknInspectDescriptionId] = {
      cateIndex: this.activeCategory,
      subCateIndex,
      itemIndex,
      seibiList: []
    };
  }

  setSaving(sknInspectDescriptionId: number) {
    const item = this.tempSaveRef[sknInspectDescriptionId];
    if (item) {
      const { subCateIndex, itemIndex } = item;
      if (subCateIndex > -1 && itemIndex > -1) {
        this.currentData[subCateIndex].inspectDescriptions[
          itemIndex
        ].isSaving = true;
      }
    }
  }

  onConfirmInspectListValue(inspectList: InspectDescriptions[]) {
    if (this.inspectList.length > 0 && this.tempBtnIndexList.length > 0) {
      this.isSocket = true;
      this.inspectList.forEach((inspect: InspectDescriptions, i: number) => {
        inspect.isSaving = true;
        inspect.inspectValueList = inspectList[i].inspectValueList;
        this.service.setButtonAfterInputValue(
          inspect,
          this.tempBtnIndexList[i],
          this.$refs.buttonGroup
        );
        this.saveInspectItem(inspect);
      });
    }
  }

  scrollToFirstIncomplete() {
    let isGoTop = true;
    const data = this.currentData;
    if (
      data.length > 0 &&
      this.routeService.isCurrentCategoryIncomplete(
        this.data,
        this.activeCategory,
        InspectButtonStatus.INCOMPLETE
      )
    ) {
      let pIndex = -1;
      let index = -1;
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].inspectDescriptions.length; j++) {
          if (
            data[i].inspectDescriptions[j].status ==
            InspectButtonStatus.NONE
          ) {
            index = j;
            pIndex = i;
            break;
          } else if (
            data[i].inspectDescriptions[j].status ==
            InspectButtonStatus.INCOMPLETE) {
            index = j;
            pIndex = i;
            break;
          }
        }
        if (index > -1) {
          break;
        }
      }
      if (index > -1) {
        isGoTop = false;
        const iDiv = this.getIndex(pIndex, index);
        const div = document.getElementById("div-row-" + iDiv);
        let wrap = document.querySelector(".select-item-wrap");
        setTimeout(() => {
          if (div && wrap) {
            const pos = div.getBoundingClientRect().top - 200;
            wrap.scrollTo(0, pos);
          }
        });
      }
    }
    if (isGoTop) {
      this.goTop();
    }
  }

  isNoSeibi(inspect: InspectDescriptions) {
    if (
      inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BASIC_OBD ||
      inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SYNC_OBD
    ) {
      return true;
    }
    return this.service.isNoSeibi(inspect);
  }

  beforeDestroy() {
    this.closeDialogWork();
    const saveState = WorkBuhinInspectionSelections.resolveInspectionSelectionsBeforeDestroySaveState({
      timerSave: this.timerSave,
      tempListSave: this.tempListSave,
      tempWaitSave: this.tempWaitSave,
      timerSaving: this.timerSaving
    });
    if (saveState.shouldClearTimerSave) {
      if (saveState.shouldFlushTempListSave) {
        this.routeService.saveInspect(this.getObjForSave());
      }
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    if (saveState.shouldFlushTempWaitSave) {
      this.saveInspectItem(this.tempWaitSave);
    }
    if (saveState.shouldClearTimerSaving) {
      clearTimeout(this.timerSaving);
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservation" });
    });
  }

  isStatusNone(item: any) {
    return this.service.isStatusNone(item);
  }

  isShow(inspect: any) {
    return WorkBuhinInspectionSelections.getInspectionSelectionsRecommendShowClass(inspect);
  }

  isDuplicate(item: any) {
    return item.isInspectDuplicate == 1;
  }

  onClickSubCategory(e: any, index: number, subIndex: number, cate: InspectGenshaCategory) {
    if (index == this.activeCategory) {
      if (subIndex != this.activeSubCategory) {
        this.changeSubCategory(subIndex);
      } else {
        this.dblclickCategory(subIndex, cate);
      }
    }
  }

  changeSubCategory(i: number) {
    const changeState = WorkBuhinInspectionSelections.buildInspectionSelectionsSubCategoryChangeState({
      activeSubCategory: this.activeSubCategory,
      nextSubCategory: i,
      categories: this.routeService.extractCurrentCategories(this.data),
      apiPath: this.apiPath,
      activeCategory: this.activeCategory
    });
    if (changeState.shouldChange) {
      this.activeSubCategory = changeState.activeSubCategory;
      this.currentData = changeState.currentData;
      setTimeout(() => {
        this.setCurrentData();
      }, 0);
      /** 2021-11-22 sh #7530 improve speed. (for back) [START] */
      /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
      this.setRouteInfo({ data: changeState.routeInfo, index: this.inspectType });
      /** 2021-11-22 sh #7530 improve speed. (for back) [END] */
      this.scrollToFirstIncomplete();
    }
  }

  isSubActive(i: number, k: number) {
    return (this.activeCategory == i && this.activeSubCategory == k);
  }

  onChangeShow(item: any, index: number) {
    const showChangeState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeShowChangeState(
      item
    );
    if (showChangeState.shouldShowDuplicateError) {
      this.errorMsg = "現車確認又は57項目点検で関連する点検項目が「×」になっている為解除できません。";
      this.$refs.errorDialog.onOpen();
    } else if (showChangeState.shouldSave) {
      Object.assign(item, showChangeState.itemState);
      this.activeInspect = showChangeState.activeInspect;
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeOsusumeStatus(item);
      this.saveSeibiItem(item);
    } else {
      this.askConfirmOsusumeChange(item, index);
    }
  }

  saveSeibiItem(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.routeService.hasRecommendCategories(this.data)) {
      const categories = this.routeService.extractCurrentCategories(this.data);
      this.service.autoSetSameRecommendSeibi(
        categories[this.activeCategory].recommend,
        inspectItem
      );
    }
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    const categoryId = this.routeService.getJizenRecommendCategoryId(
      this.data,
      this.activeCategory,
      this.activeSubCategory
    );
    const saveQueueItem = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeSaveQueueItem({
      inspectItem,
      categoryId
    });
    let objForSave: InspectRecommendSubItem = saveQueueItem.item;
    this.arrStatus.push(saveQueueItem.status);
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
      }
    }
    if (this.isSaving) {
      this.tempWaitSave = WorkBuhinInspectionSelections.upsertInspectionSelectionsOsusumeSaveQueue(
        this.tempWaitSave,
        objForSave
      );
    } else {
      const saveData = this.getObjForSaveOsusume(inspectItem);
      this.saveAndUpdateData(saveData);
    }
  }

  findSeibiIndex(list: any, seibiSave: any) {
    return WorkBuhinInspectionSelections.findInspectionSelectionsOsusumeSaveIndex(list, seibiSave);
  }

  getObjForSaveOsusume(item: any = null) {
    let items: any = [];
    if (!item) {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items = this.tempListSave;
      items = this.utils.deepCopy(this.tempListSave);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    } else {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items.push(item);
      items = items.concat(item);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    }
    const categoryId = this.routeService.getJizenRecommendCategoryId(
      this.data,
      this.activeCategory,
      this.activeSubCategory
    );
    return WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeSavePayload({
      items,
      uketsukeExtendsId: this.uketsukeExtendsId,
      categoryId,
      isSocket: this.getIsSocket(),
      doneStatus: STATUS_SELECT_WORK_BUHIN.Done,
      deleteStatus: STATUS_SELECT_WORK_BUHIN.delete,
      recommendManualType: INSPECT_TYPE.RECOMMEND_MANUAL
    });
  }

  saveAndUpdateData(data: any, isUpdateAll: boolean = false) {
    this.isSaving = true;
    this.reqService.saveJizenRecommend(data).then( // sendSocket:ソケット仮27
      (res: any) => {
        if (res.status == 200 && res.body) {
          this.isSocket = true;
          this.finishOsusumeSave(data);
          this.tempListSave = [];
          this.arrStatus = [];
          this.initData(res.body);
        } else {
          this.finishOsusumeSave(data);
        }
      },
      error => {
        console.error("error", error.rsltComment);
        this.finishOsusumeSave(data);
      }
    );
  }

  finishOsusumeSave(data: any) {
    const recommend = this.routeService.extractFirstSavedRecommend(data);
    this.currentData = WorkBuhinInspectionSelections.clearInspectionSelectionsSavedItemSavingState({
      currentData: this.currentData,
      subItemKeys: WorkBuhinInspectionSelections.getInspectionSelectionsSavedSubItemKeys(recommend),
      manualItemKeys: WorkBuhinInspectionSelections.getInspectionSelectionsSavedManualItemKeys(recommend),
      pendingItems: this.tempWaitSave
    });
    this.isSaving = false;
    if (this.tempWaitSave && this.tempWaitSave.length > 0) {
      const pendingItems = this.utils.deepCopy(this.tempWaitSave);
      this.tempWaitSave = [];
      this.saveAndUpdateData(this.getObjForSaveOsusume(pendingItems));
    }
  }

  initData(res: any) {
    const recommendCategories =
      this.routeService.extractFirstCategoryRecommendCategories(res);
    if (recommendCategories.length > 0) {
      const savedRecommendState =
        WorkBuhinInspectionSelections.buildInspectionSelectionsSavedRecommendCategoriesState({
          recommendCategories,
          maxRowNum: this.maxRowNum,
          normalizeItem: (obj: any) => {
            this.changeOsusumeStatus(obj, false);
            return obj;
          }
      });
      this.maxRowNum = savedRecommendState.maxRowNum;
      savedRecommendState.categoryStatuses.forEach((status: any) => {
        this.setOsusumeCateStatus(status.sumStatus, status.nItem, status.cate);
      });
      Promise.resolve(savedRecommendState.recommendCategories).then(
        (val: any) => {
          const activeRecommend = WorkBuhinInspectionSelections.resolveInspectionSelectionsActiveRecommend({
            data: this.data,
            activeCategory: this.activeCategory,
            activeSubCategory: this.activeSubCategory
          });
          const applyState = WorkBuhinInspectionSelections.buildInspectionSelectionsSavedRecommendApplyState({
            activeRecommend,
            savedRecommend: val[0],
            deleteStatus: STATUS_SELECT_WORK_BUHIN.delete
          });
          if (!applyState.shouldUpdate) {
            return;
          }
          activeRecommend.subItems = applyState.subItems;
          this.setInspectRecommend(this.data);
          this.setOsusumeCurrentData();
        }
      );
    }
  }

  changeOsusumeStatus(item: InspectRecommendSubItem, checkCate?: boolean) {
    this.service.changeStatusRecommendSeibi2(item);
    if (checkCate !== false) {
      this.changeOsusumeCateStatus();
    }
  }

  changeOsusumeCateStatus() {
    const statusInput = WorkBuhinInspectionSelections.buildInspectionSelectionsCategoryStatusInput(
      this.currentData
    );
    this.setOsusumeCateStatus(statusInput.sumStatus, statusInput.nItem);
  }

  setOsusumeCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectRecommendCategory
  ) {
    if (cate == null) {
      cate = this.routeService.getActiveRecommendCategory(
        this.data,
        this.activeCategory,
        this.activeSubCategory
      );
    }
    if (cate) {
      cate.status = WorkBuhinInspectionSelections.resolveInspectionSelectionsCategoryStatus({
        sumStatus,
        nItem,
        noneStatus: InspectButtonStatus.NONE,
        completedStatus: InspectButtonStatus.COMPLETED,
        incompleteStatus: InspectButtonStatus.INCOMPLETE
      });
    }
  }

  onCloseOsusumeBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    const closeState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeCloseState(
      event,
      this.activeInspect
    );
    if (closeState.shouldSave) {
      this.isSocket = closeState.isSocket;
      this.changeOsusumeStatus(closeState.activeInspect);
      this.saveSeibiItem(closeState.activeInspect);
      /** 2021-10-01 sh #7411 put loading after add buhin. [START] */
      Object.assign(this.activeInspect, closeState.itemState);
      /** 2021-10-01 sh #7411 put loading after add buhin. [END] */
    }
    this.$set(this, "activeInspect", {});
  }

  showOsusumeWork(event: any, item: any) {
    if (item.isSaving) {
      return;
    }
    const toggleState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeWorkToggleState(item);
    Object.assign(item, toggleState.itemState);
    this.activeInspect = toggleState.activeInspect;
  }

  setOsusumeCurrentData() {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    const currentDataState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeCurrentDataState({
      data: this.data,
      activeCategory: this.activeCategory,
      activeSubCategory: this.activeSubCategory,
      isSaving: this.isSaving
    });
    this.kingakuFlg = currentDataState.kingakuFlg;
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    if (!currentDataState.shouldUpdate) {
      return;
    }
    this.loadData = currentDataState.loadData;
    this.currentData = []; // 一旦空にする
    Promise.all(currentDataState.currentData).then(vals => {
      vals.map((val: any, i: number) => {
        this.$set(this.currentData, i, this.utils.deepCopy(val));
      });
    });
  }

  isOsusumeDisabled(item: InspectRecommendSubItem) {
    return WorkBuhinInspectionSelections.isInspectionSelectionsOsusumeDisabled(item);
  }

  hasOsusumeValueWork(inspect: any) {
    return WorkBuhinInspectionSelections.getInspectionSelectionsWorkValueClass({
      selectedValue: inspect.buhinSelected,
      isIncomplete: this.isIncomplete(inspect)
    });
  }

  onConfirmOsusumeBuhin(item: InspectRecommendSubItem) {
    /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [START] */
    /** おすすめの場合、先に部品の子画面を開くことはないので、ここでフラグを立てる */
    const confirmState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeConfirmState(item);
    Object.assign(item, confirmState.itemState);
    /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [END] */
    if (confirmState.shouldChangeStatus) {
      this.changeOsusumeStatus(confirmState.item);
    }
    if (confirmState.shouldSave) {
      this.saveOsusumeBuhin(confirmState.item);
    }
  }

  saveOsusumeBuhin(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.routeService.hasRecommendCategories(this.data)) {
      this.service.autoSetSameRecommendSeibi(
        this.routeService.extractRecommendCategories(this.data),
        inspectItem
      );
    }
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    const categoryId = this.routeService.getRecommendCategoryId(
      this.data,
      this.activeCategory
    );
    const saveQueueItem = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeSaveQueueItem({
      inspectItem,
      categoryId
    });
    let objForSave: InspectRecommendSubItem = saveQueueItem.item;
    this.arrStatus.push(saveQueueItem.status);
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
      }
    }
    // ダイアログ内の確定は保持だけ行い、閉じる時に最新の内容を保存する。
    this.tempOsusumeListSave = WorkBuhinInspectionSelections.upsertInspectionSelectionsOsusumeSaveQueue(
      this.tempOsusumeListSave,
      objForSave
    );
  }

  askConfirmOsusumeChange(item: InspectRecommendSubItem, index: number) {
    this.$refs.osusumeConfirmDialog.onOpen();
    this.tempOsusumeInspect = item;
    this.tempIndex = index;
  }

  onConfirmChangeOsusumeInspect() {
    const hideState = WorkBuhinInspectionSelections.buildInspectionSelectionsConfirmHideOsusumeState({
      item: this.tempOsusumeInspect,
      completedStatus: InspectButtonStatus.COMPLETED,
      initialBuhinStatus: STATUS_SELECT_WORK_BUHIN.Initial
    });
    this.arrStatus.push(hideState.arrStatusValue);
    this.activeInspect = hideState.activeInspect;
    Object.assign(this.tempOsusumeInspect, hideState.itemState);
    this.service.setInspectResultRecomend2(0, this.tempOsusumeInspect);
    if (hideState.shouldDeleteBuhin) {
      this.deleteAlManualBuhin(this.tempOsusumeInspect);
      this.service.deletAllBuhinInSeibi([this.tempOsusumeInspect]);
      this.tempOsusumeInspect.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
    this.changeOsusumeStatus(this.tempOsusumeInspect);
    this.saveSeibiItem(this.tempOsusumeInspect);
    this.$refs.osusumeConfirmDialog.onClose();
  }

  onCancelChangeOsusumeInspect() {
    this.$refs.osusumeConfirmDialog.onClose();
  }

  deleteAlManualBuhin(item: any) {
    if (item.manualBuhinList.length > 0) {
      const manualBuhinList = this.utils.deepCopy(item.manualBuhinList);
      item.manualBuhinList = [];
      manualBuhinList.forEach((buhin: any) => {
        if (buhin.id) {
          this.reqService.deleteManualBuhin(buhin.id);
        }
      });
    }
  }

  isOBD(subCate: InspectGenshaCategory) {
    if (subCate.sknInspectCategoryNm.trim() == "OBDの診断の結果"
      || subCate.sknInspectCategoryNm.trim() == "ﾒｰﾀｰﾊﾟﾈﾙ警告灯状態") {
      return true;
    }
    return false;
  }
  /** 2021-11-08 sh #7530 improve speed.(No.1) [START] */
  getInspectByCategoryId(sknUketsukeExtendsId: any, apiPath: any, sknInspectCategoryId: any) {
    const promise = this.getInspectByCategoryIdPM(sknUketsukeExtendsId, apiPath, sknInspectCategoryId);

    Promise.all([promise]).then((val: any) => {
      if (val.length>0) {
        this.routeService.applyCategorySubItems(
          this.data,
          sknInspectCategoryId,
          val[0]
        );
        /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
        this.$set(this.cateLoadingList, sknInspectCategoryId, false);
        /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
        this.addStatus();
      }
    }, (err: any) => {
      // エラー処理
      /** 2021-12-09 sh #7610 stop loading if subItems is none. [START] */
      this.$set(this.cateLoadingList, sknInspectCategoryId, false);
      /** 2021-12-09 sh #7610 stop loading if subItems is none. [END] */
    });
  }
  getInspectByCategoryIdPM(sknUketsukeExtendsId: any, apiPath: any, sknInspectCategoryId: any) {
    /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
    this.$set(this.cateLoadingList, sknInspectCategoryId, true);
    /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
    const promise = new Promise((resolve, reject) => {
      this.routeService.getInspectByCategoryId(
        sknUketsukeExtendsId,
        sknInspectCategoryId,
        this.strSknSeibiShubetsuKbn
      )
      .then((res: any)=> {
        const subItems = this.routeService.extractCategorySubItems(
          res,
          sknInspectCategoryId
        );
        if (subItems.length > 0) {
          resolve(subItems);
        } else {
          reject();
        }
      }, (err: any) => reject(err));
    });

    return promise;
  }
  /** 2021-11-08 sh #7530 improve speed.(No.1) [END] */

  /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
  isCateLoading(category: any) {
    const key =  category.sknInspectCategoryId;
    if (key in this.cateLoadingList) {
      if (this.cateLoadingList[key] == true) {
        return true;
      }
    }
    return false;
  }

  cateRefName(pos: any) {
    return "cate-" + pos;
  }
  /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  isShowAll(show: number) {
    return this.currentData.every((seibi: any) => seibi.osusumeIsShow == show);
  }

  // 全て提案する
  showAll() {
    if (this.isShowAll(1)) {
      return;
    }
    this.currentData.forEach((item: any) => {
      item.osusumeIsShow = 1;
      if (item.buhinList && item.buhinList.length == 0 
        && item.osusumeBuhinList && item.osusumeBuhinList.length == 0
      ) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (!item.osusumeBuhinList && item.buhinBunruiList 
        && item.buhinBunruiList.length == 0 && item.buhinList && item.buhinList.length == 0
      ) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (item.osusumeBuhinList && item.osusumeBuhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else if (item.buhinList && item.buhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
        if (item.buhinList && item.buhinList.length > 0) {
          item.buhinList = new Array();
        }
        if (item.osusumeBuhinList && item.osusumeBuhinList.length > 0) {
          item.osusumeBuhinList = new Array();
        }
      }
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeOsusumeStatus(item);
      this.arrStatus.push(item.status || 0);
    });
    this.saveOsusumeCurrentData();
  }

  // 全て提案しない
  hideAll() {
    if (this.isShowAll(0)) {
      return;
    }
    this.currentData.forEach((item: any, i) => {
      if (item.isInspectDuplicate == 0) {
        item.osusumeIsShow = 0;
        this.service.setInspectResultRecomend2(item.inspectResult, item);
        this.deleteAlManualBuhin(item);
        this.service.deletAllBuhinInSeibi([item]);
        this.arrStatus.push(item.status || 0);
      }
    });
    this.saveOsusumeCurrentData();
  }

  // 全て提案する/しない
  saveOsusumeCurrentData() {
    this.currentData.forEach(seibi => {
      seibi.isSaving = true;
    });
    const saveState = WorkBuhinInspectionSelections.buildInspectionSelectionsOsusumeCurrentSaveState({
      currentData: this.utils.deepCopy(this.currentData),
      data: this.data,
      activeCategory: this.activeCategory,
      activeSubCategory: this.activeSubCategory
    });
    if (saveState.shouldSave) {
      const saveData = this.getObjForSaveOsusume(saveState.items);
      this.saveAndUpdateData(saveData, true);
    }
  }
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
  seibiNm: string = "";
  kouchinZn: any = null;
  kouchinZk: any = null;
  addcurrentData() {
    if (this.seibiNm.length > 0) {
      this.arrStatus.push(InspectButtonStatus.COMPLETED);
      this.saveManualItem();
    }
  }
  saveManualItem() {
    this.isSaving = true;
    const activeRecommend = this.routeService.getActiveRecommendCategory(
      this.data,
      this.activeCategory,
      this.activeSubCategory
    );
    const manualItem = WorkBuhinInspectionSelections.buildInspectionSelectionsManualRecommendItemSave({
      uketsukeExtendsId: this.uketsukeExtendsId,
      seibiNm: this.seibiNm,
      kouchinZn: this.kouchinZn,
      kouchinZk: this.kouchinZk,
      recommendCategoryId: activeRecommend.sknRecommendInspectCategoryId,
      inspectCategoryId:
        activeRecommend.subItems[0].sknRecommendInspectCategoryId,
      doneStatus: STATUS_SELECT_WORK_BUHIN.Done,
      recommendManualType: INSPECT_TYPE.RECOMMEND_MANUAL
    });
    const data =
      WorkBuhinInspectionSelections.buildInspectionSelectionsManualRecommendSavePayload(manualItem);
    this.reqService.saveJizenInspectRecommendManual(data).then( // sendSocket:ソケット仮28
      (res: any) => {
        if (res.status == 200 && res.body) {
          let d: any = WorkBuhinInspectionSelections.buildInspectionSelectionsAddedManualRecommendItem({
            uketsukeExtendsId: this.uketsukeExtendsId,
            seibiId: res.body,
            seibiNm: this.seibiNm,
            kouchinZn: this.kouchinZn,
            doneStatus: STATUS_SELECT_WORK_BUHIN.Done,
            completedStatus: InspectButtonStatus.COMPLETED,
            recommendManualType: INSPECT_TYPE.RECOMMEND_MANUAL,
            rowNum: this.currentData.length,
            recommendCategoryId: this.routeService.getRecommendCategoryId(
              this.data,
              this.activeCategory,
              0
            )
          });
          this.currentData.push(d);
          const currentRecommend = this.routeService.getActiveRecommendCategory(
            this.data,
            this.activeCategory,
            this.activeSubCategory
          );
          if (currentRecommend &&
            currentRecommend.subItems &&
            currentRecommend.subItems.length > 0) {
            currentRecommend.subItems.push(d);
            // console.log(this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems);
          }
          this.seibiNm = "";
          this.kouchinZn = null;
          this.kingakuFlg = false;
        }
        this.isSaving = false;
      },
      error => {
        console.error("error", error);
        this.isSaving = false;
      }
    );
  }
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]

  gotoFactoryCustomer() {
    this.reqService.getReservationTarget(this.uketsukeExtendsId,0)
    .then((res: any) => {
      if (res.length > 0) {

        res.forEach((e: any, i: number) => {
          if ( e.uketsukeCd == e.uketsukeParentCd || e.uketsukeParentCd == "") {
            this.$router.push({
              name: "customer",
              params: { code: e.uketsukeCd }
            });
          }
        });
        
      }
    });
  }
}
